import createReducer from '../utils/createReducer';
import {
  ADDRESS_SETTINGS_REQUEST,
  ADDRESS_SETTINGS_SUCCESS,
  ADDRESS_SETTINGS_FAILURE,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [ADDRESS_SETTINGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [ADDRESS_SETTINGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data ? [].concat(payload.data) : [],
      token: payload.token,
    })
  ),
  [ADDRESS_SETTINGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/addressSettings.js